import React from 'react'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'

class TextFieldField extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      value: props.input.value
    }
    this.inputRef = React.createRef()
  }
  componentDidMount () {
    if (this.props.value) {
      this.setState({ value: this.props.value })
    }
  }

  render () {
    const {
      id,
      input: {
        value: inputValue,
        ...restInput
      },
      placeholder,
      type,
      meta: { touched, error },
      block,
      disabled,
      options
    } = this.props
    const MenuItems = options.map((i, index) => {
      return <MenuItem key={i.value} value={i.value}>{i.label}</MenuItem>
    })
    const {
      value
    } = this.state
    return (
      <TextField
        id={id}
        select
        defaultValue={value || ''}
        fullWidth={block}
        inputRef={this.inputRef}
        onChange={this.handleChange}
        helperText={touched && error}
        error={touched && !!error}
        label={placeholder}
        type={type}
        margin='normal'
        inputProps={{
          'data-testid': `test-${id}`,
          disabled: disabled
        }}
        FormHelperTextProps={{
          'data-testid': `test-${id}-helper-text`
        }}
        {...restInput}
      >
        {MenuItems}
      </TextField>
    )
  }
  handleChange = e => {
    const {
      normalizers,
      input: {
        onChange
      }
    } = this.props
    const {
      TextFieldionStart,
      TextFieldionEnd
    } = this.inputRef.current
    const newValue = normalizers
      ? normalizers.reduceRight((val, fn) => fn(val), e.target.value)
      : e.target.value
    this.setState({
      value: newValue
    }, () => {
      this.inputRef.current.setTextFieldionRange(TextFieldionStart, TextFieldionEnd)
      onChange(newValue)
    })
  }
}

export default TextFieldField
